angular
.module( 'ribytRsvpApp' )
.directive( 'ticket', function ( $sessionStorage, $rootScope, $state, $timeout, moment, $sce, $window, variableSubstitution ) {
    return {
        'restrict': 'E',
        'scope': {
            'ticketData': '=',
            'bartext': '=',
            'index': '=',
            'total': '=',
            'eventDigitalLink': '@',
            'eventLocation': '@',
            'eventName': '=',
            'inviteData': '='
        },
        'templateUrl': 'views/directives/tickets/ticket.html',
        'link': function ( scope, element, attrs ) {
            var addressInfo = ['address', 'locality', 'region', 'postcode'];
            scope.location = [];
            scope.preview = $rootScope.preview;
            scope.eventLocation = JSON.parse( scope.eventLocation );

            var invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

            scope.isTimeFormat24 = invite.experienceID.RSVPDetails.isTimeFormat24;
            // For mobile ticket page body background-color
            if ( $window.innerWidth < '768' ) {
                document.getElementsByTagName( 'body' )[0].style.setProperty( 'background-color', 'white' );
            }

            scope.invite = invite;
            scope.inviteData = {
                'eventName': _.get( invite, 'eventID.name' ),
                'inviteType': _.get( invite, 'type' ),
                'guestID': _.get( invite, 'guestID' ),
                'ticketPageDetails': _.get( invite, 'experienceID.ticketPageDetails' )
            };

            scope.showHeaderImage = true;
            scope.showHeaderText = true;
            scope.showHeaderTitle = true;
            if ( scope.inviteData.ticketPageDetails && scope.inviteData.ticketPageDetails.isHideField ) {
                scope.showHeaderImage = scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerImage' ) ? !scope.inviteData.ticketPageDetails.isHideField.headerImage : true;
                scope.showHeaderText = scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerText' ) ? !scope.inviteData.ticketPageDetails.isHideField.headerText : true;
                scope.showHeaderTitle = scope.inviteData.ticketPageDetails.isHideField.hasOwnProperty( 'headerTitle' ) ? !scope.inviteData.ticketPageDetails.isHideField.headerTitle : true;
            }

            scope.trustedHtml = function ( plainText ) {
                return $sce.trustAsHtml( variableSubstitution.doSubstitutions( plainText ) );
            };

            // Customize Ticket Header and name color
            scope.headerbarBg = _.get( scope.ticketData, 'bytID.ticketDetails.headerbarBg' );
            scope.ticketNameColor = _.get( scope.ticketData, 'bytID.ticketDetails.ticketNameColor' );

            var startDay = moment( scope.ticketData.bytID.datetimeStart.split( ' ' )[0] );
            var endDay = moment( scope.ticketData.bytID.datetimeEnd.split( ' ' )[0] );
            scope.daysRange = endDay.diff( startDay, 'days' );

            scope.ticketBannerImageSrc = $rootScope.getTicketBannerImagePath( scope.invite, scope.ticketData, 'bytID.ticketDetails.image' );

            // Prevent showing print popup when user using print hotkey
            $window.addEventListener( 'keydown', function( event ) {
                if ( event.keyCode == 80 && (event.ctrlKey || event.metaKey ) ) {
                    event.stopPropagation();
                    event.preventDefault();
                    $rootScope.getPDF();
                }
            } );

            // Generate PDF when user using browser print click.
            $window.onbeforeprint = function() {
                angular.forEach( angular.element( '.ticket-real-print' ), function( elem, key ) {
                    elem.style.display = 'block';
                } );
                angular.forEach( angular.element( '.ticket-pdf-print' ), function( elem, key ) {
                    elem.style.display = 'none';
                } );
                $rootScope.getPDF();
            };
            $window.onafterprint = function() {
                angular.forEach( angular.element( '.ticket-real-print' ), function( elem, key ) {
                    elem.style.display = 'none';
                } );
                angular.forEach( angular.element( '.ticket-pdf-print' ), function( elem, key ) {
                    elem.style.display = 'block';
                } );
            };

            scope.barcodeStyle = scope.ticketData.bytID.ticketDetails.barcodeType === 'Code 128' ? 'ticket-barcode-panel-128' : 'ticket-barcode-panel';

            var hasAddress = false;
                // setup the location information in an array so we can read it easier on the FE
            _.forEach( addressInfo, function ( address ) {
                var addComma = ',';
                if ( address === 'postcode' || address === 'region' ) {
                    addComma = '';
                }

                var bytAddressType = _.trim( _.get( scope, 'ticketData.bytID.locationData.' + address, '' ) );

                if ( bytAddressType && bytAddressType !== '' ) {
                    scope.location.push( bytAddressType + addComma );
                    hasAddress = true;
                }
            } );

            if ( scope.ticketData.bytID.useEventLocation ) {
                if ( scope.eventLocation && scope.eventLocation.formatted_location ) {
                    scope.location = [scope.eventLocation.formatted_location, scope.eventLocation.venue].filter( Boolean ).join( ', ' );
                } else {
                    scope.location = '';
                    scope.digitalLink = scope.eventDigitalLink;
                }
            } else {
                scope.location = scope.location.join( ' ' );
            }

            var nameInfo = ['title', 'prefix', 'first', 'middle', 'last', 'suffix'];
            scope.guestName = [];
            _.forEach( nameInfo, function ( name ) {
                var bytAddressType = _.trim( _.get( scope, 'inviteData.guestID.name.' + name, '' ) );
                scope.guestName.push(bytAddressType);
            } );
            scope.guestName = scope.guestName.join( ' ' );
            scope.guestPureName = scope.invite.guestID.name.first + ' ' + scope.invite.guestID.name.last;

            scope.seatForBarcode = function seatForBarcode ( barcode ) {
                var seat = ( scope.ticketData.bytDetails.seats || [] ).find( function findSeat ( seat ) {
                    return seat.barcode === barcode;
                } );
                return seat && seat.label;
            };
            if ( !_.get( scope.ticketData, 'bytID.ticketLabel' ) ) {
                _.set( scope.ticketData, 'bytID.ticketLabel', 'Purchased By' );
            } else if ( _.get( scope.ticketData, 'bytID.ticketLabel' ) === 'Other' ) {
                _.set( scope.ticketData, 'bytID.ticketLabel', _.get( scope.ticketData, 'bytID.ticketLabelCustom', 'Purchased By' ) );
            } else if ( _.get( scope.ticketData, 'bytID.ticketLabel' ) === 'None' ) {
                _.set( scope.ticketData, 'bytID.ticketLabel', null );
            }

            $timeout( function () {
                // http://www.jqueryscript.net/other/Simple-jQuery-Based-Barcode-Generator-Barcode.html
                if (scope.bartext && _.get( scope.ticketData, 'bytID.ticketDetails.barcodeType' )) {
                    var type = '';
                    switch ( _.get( scope.ticketData, 'bytID.ticketDetails.barcodeType' ) ) {
                    case 'Interleaved 2 of 5':
                        type = 'int25';
                        break;
                    case 'Code 128':
                        type = 'code128';
                        break;
                    default:
                        type = 'int25';
                    }

                    var screenWidth = $window.innerWidth;

                    var settings = {
                        'barWidth': screenWidth < 400 ? '1' : '2',
                        'barHeight': screenWidth < 992 ? '70' : '60',
                        'fontSize': screenWidth < 400 ? '12' : '18'
                    };

                    if ( screenWidth < 992 ) {
                        $( '#barcode' + scope.ticketData.bytID.id + scope.index ).barcode( scope.bartext, type, settings );
                    } else {
                        $( '#barcode' + scope.ticketData.bytID.id + scope.index + '-desktop' ).barcode( scope.bartext, type, settings );
                    }

                }
            } );
        }
    };
} );
